const palette = {
  background: {
    default: "#f3f6f8"
  },
  primary: {
    dark: "#006712",
    main: "#01821A",
    light: "#0E9D27"
  },
  secondary: {
    dark: "#000",
    main: "#333",
    light: "#929191"
  },
  warning: {
    light: "#F6D89C",
    main: "#E9B550",
    dark: "#CE9423"
  },
  error: {
    light: "#EF8E80",
    main: "#D5351F",
    dark: "#A71805"
  },
  custom: {
    blue: "#5677FC",
    green: "#42BD41",
    border: "rgba(0, 0, 0, .23)"
  }
};

export default palette;
